var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//  @jsx h

import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';
var style = {
  'scrubber': 'dhfc-1_0_0-beta_28-scrubber',
  'scrubber__bgBar': 'dhfc-1_0_0-beta_28-scrubber__bgBar',
  'scrubber__bufferedBar': 'dhfc-1_0_0-beta_28-scrubber__bufferedBar',
  'scrubber__playedBar': 'dhfc-1_0_0-beta_28-scrubber__playedBar'
};

var Scrubber = function (_PureComponent) {
  _inherits(Scrubber, _PureComponent);

  function Scrubber() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scrubber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scrubber.__proto__ || Object.getPrototypeOf(Scrubber)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      left: 0,
      width: 0,
      isScrubbing: false,
      position: null
    }, _this.handleKeyDown = function (evt) {
      var _this$props = _this.props,
          duration = _this$props.duration,
          time = _this$props.time,
          onPositionUpdate = _this$props.onPositionUpdate;


      if (onPositionUpdate) {
        var nextTime = time;

        switch (evt.key) {
          case 'ArrowLeft':
            nextTime -= 1;
            break;
          case 'ArrowRight':
            nextTime += 1;
            break;
        }

        onPositionUpdate(Math.max(Math.min(nextTime / duration, 1), 0));
      }
    }, _this.handleMouseDown = function (evt) {
      evt.preventDefault();
      _this.focus();
      _this.start(evt.pageX);
      _this.elm.addEventListener('mousemove', _this.handleMouseMove);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseMove = function (evt) {
      _this.move(evt.pageX);
    }, _this.handleMouseUp = function (evt) {
      _this.focus();
      _this.end();
      _this.elm.removeEventListener('mousemove', _this.handleMouseMove);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleResize = function () {
      var rect = _this.bgElm.getBoundingClientRect();

      _this.setState({
        left: Math.floor(rect.left),
        width: rect.width
      });
    }, _this.handleTouchStart = function (evt) {
      if (evt.touches.length === 1) {
        evt.preventDefault();
        _this.focus();
        _this.start(evt.touches[0].clientX);
        _this.elm.addEventListener('touchmove', _this.handleTouchMove);
        window.addEventListener('touchend', _this.handleTouchEnd);
      }
    }, _this.handleTouchMove = function (evt) {
      if (evt.touches.length === 1) {
        _this.move(evt.touches[0].clientX);
      }
    }, _this.handleTouchEnd = function (evt) {
      _this.focus();
      _this.end();
      _this.elm.removeEventListener('touchmove', _this.handleTouchMove);
      window.removeEventListener('touchend', _this.handleTouchEnd);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Scrubber, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onPositionUpdate) {
        this.elm.addEventListener('keydown', this.handleKeyDown);
        this.elm.addEventListener('mousedown', this.handleMouseDown);
        this.elm.addEventListener('touchstart', this.handleTouchStart);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onPositionUpdate) {
        this.elm.removeEventListener('keydown', this.handleKeyDown);
        this.elm.removeEventListener('mousedown', this.handleMouseDown);
        this.elm.removeEventListener('touchstart', this.handleTouchStart);
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handleElm.focus();
    }
  }, {
    key: 'start',
    value: function start(clientX) {
      if (this.positionTimeout) {
        clearTimeout(this.positionTimeout);
      }

      this.setState({
        position: (clientX - this.state.left) / this.state.width,
        isScrubbing: true
      });
    }
  }, {
    key: 'move',
    value: function move(clientX) {
      this.setState({
        position: Math.max(Math.min((clientX - this.state.left) / this.state.width, 1), 0)
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var _this2 = this;

      if (this.props.onPositionUpdate && this.state.position !== null) {
        this.props.onPositionUpdate(this.state.position);
      }

      this.setState({
        isScrubbing: false
      });

      this.positionTimeout = setTimeout(function () {
        _this2.setState({
          position: null
        });
      }, 350);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          duration = _props.duration,
          time = _props.time;

      var className = '' + style.scrubber + (this.props.className ? ' ' + this.props.className : '');
      var position = this.state.position !== null ? this.state.position : time / duration;

      return h(
        'div',
        { className: className, ref: function ref(elm) {
            return _this3.elm = elm;
          } },
        h('div', {
          className: style.scrubber__bgBar,
          ref: function ref(bgElm) {
            return _this3.bgElm = bgElm;
          }
        }),
        h('div', { className: style.scrubber__bufferedBar }),
        h('div', {
          className: style.scrubber__playedBar,
          style: { width: position * 100 + '%' }
        }),
        h('button', {
          ref: function ref(handleElm) {
            return _this3.handleElm = handleElm;
          },
          role: 'slider',
          'aria-valuemin': '0',
          'aria-valuemax': duration * 1000,
          'aria-valuenow': time * 1000,
          style: { left: position * 100 + '%' }
        })
      );
    }
  }]);

  return Scrubber;
}(PureComponent);

export default Scrubber;